import { Router, ActivatedRoute } from '@angular/router';
import { EventEmitter } from '@angular/core';
// Import global data service
import { DataService, Loading } from 'src/app/Services/Data/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { DatabindingService } from 'src/app/Services/Databinding/databinding.service';
import { GoogleAnalyticsService } from 'src/app/Services/google-analytics.service';
import { APP_BASE_LINK } from 'src/environments/constants';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css']
})
export class PreviewComponent implements OnInit {
  edit_document: boolean = false;
  edit_document_url: any;

  document_id: string;
  document: any = [];
  document_name: string = '';
  sender_email: string = '';

  // pushback
  selected_pushback_document: any;
  pushback_type: any = { name: '' }; // it can be changed by reference in databinding-form
  display_pushback: boolean = false;

  // type
  record_type: string = 'SALESFORCE_RECORD_TYPE ';

  // Loading
  loading: Loading;

  // error
  error_messages: any = [];

  // tabs
  current_tab: string;

  // template_settings
  template_setting: any;
  template_setting_id: string;
  using_template_setting: boolean;
  skip_to_email_invite: boolean;

  // classes for tabs
  pushback_class: string;
  setup_class: string;

  salesforce_session_data: any;

  onDocumentSelected: EventEmitter<any>;
  sfObjectsList = [];
  sfCurrObjMetaList = [];
  pushBackErrorsMsg = {
    cannotAddPushbackToRecord: `Cannot save Data Binding without a specified 'Salesforce Record Type'. Please update Data Binding.`,
    cannotAssignPushbackRecord: `Cannot save Data Binding without at least one specified 'Salesforce Field Name'. Please update Data Binding.`,
    duplicatePushbackField:
      'Duplicate field values detected for Salesforce Data Binding. Please ensure all field values for updating a record are unique.',
    duplicatePushbackTypes:
      'Duplicate Salesforce Type values. Please make sure that there is only one Type value for Data Binding.'
  };

  // Data
  data: any = [];
  salesforce: any = [];
  document_group: any = [];

  // Signing Link
  is_signing_link: boolean = false;
  isCopiedToClipboard: boolean = false;
  signingLinkString: string = '';
  signingLinkParams: string = '';
  isAllowToInvite: boolean = false;
  isInviterWillGuest: boolean = false;
  singningLinkFlag = 'signingLink';

  is_show_overwritten_info: boolean = false;
  sending_type: string = 'unresolved';

  loadInfo() {
    this.data = this.dataService.getData();
    this.salesforce = this.dataService.getSalesforceData();
    this.record_type = 'SALESFORCE_RECORD_TYPE (' + this.salesforce.record_type + ')';
    this.sfObjectsList.push(this.salesforce.record_type);
    this.document_group = this.dataService.getDocumentGroup();
    this.using_template_setting = this.data.using_template_setting;

    try {
      this.sender_email = JSON.parse(this.salesforce.context).user.email;
    } catch {}

    if (this.data.using_template_setting == true) {
      this.template_setting = this.data.template_setting;
      this.skip_to_email_invite = this.template_setting.skip_to_email_invite;
    }
  }

  constructor(
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private databindingService: DatabindingService,
    private GA: GoogleAnalyticsService
  ) {
    this.loading = dataService.getLoading();
    this.onDocumentSelected = new EventEmitter();
    renderer.listen('window', 'message', this.handleMessage.bind(this));

    this.sending_type = this.activatedRoute.snapshot.queryParamMap.get('sending_type');
  }
  handleMessage(event: Event) {
    const message = event as MessageEvent;
    if (message.data === 'close_popup') {
      this.edit_document = false;
      this.edit_document_url = '';
    }
  }

  setTabs(tab) {
    this.clearErrors();
    if (tab === 'setup') {
      this.current_tab = 'setup';
      this.setup_class = 'tab-pane fade in active';
      this.pushback_class = 'tab-pane fade';
    } else if (tab === 'pushback') {
      this.current_tab = 'pushback';
      this.pushback_class = 'tab-pane fade in active';
      this.setup_class = 'tab-pane fade';
    }
  }

  ngOnInit() {
    this.skip_to_email_invite = false;
    this.loadInfo();
    this.setTabs('setup');
    this.document_id = this.data.document_id;
    this.updateLoading(true, 'Loading document data.');
    this.dataService
      .apiGetCall('/api/get_document?document_id=' + this.document_id)

      .subscribe((result) => {
        this.document = result;

        if (this.using_template_setting && this.template_setting.template_id) {
          // starting process for copying fields from template to selected document
          this.updateLoading(true, 'Loading template data.');

          // getting the template from which we want to get the fields
          this.dataService
            .apiGetCall('/api/get_document?document_id=' + this.template_setting.template_id)

            .subscribe(
              (templateDocument) => {
                this.updateLoading(true, 'Updating document fields.');
                // copying and setting fields
                const fieldsFromTemplate = JSON.parse(JSON.stringify(templateDocument.fields)) || [];

                for (let i = 0; i < fieldsFromTemplate.length; i++) {
                  if (fieldsFromTemplate[i].json_attributes) {
                    fieldsFromTemplate[i] = Object.assign(
                      fieldsFromTemplate[i],
                      fieldsFromTemplate[i].json_attributes
                    );
                  }

                  if (fieldsFromTemplate[i].type === 'enumeration') {
                    fieldsFromTemplate[i].enumeration_options = [];
                    for (let idx = 0; idx < templateDocument.enumeration_options.length; idx++) {
                      if (
                        templateDocument.enumeration_options[idx].enumeration_id === fieldsFromTemplate[i].id
                      ) {
                        fieldsFromTemplate[i].enumeration_options.push(
                          templateDocument.enumeration_options[idx].data
                        );
                      }
                    }
                  }
                }

                this.dataService
                  .apiPostCall('/api/post_fields_to_document?document_id=' + this.document_id, {
                    fields: fieldsFromTemplate
                  })

                  .subscribe(
                    () => {
                      if (
                        templateDocument.fields &&
                        templateDocument.fields.length &&
                        this.document.fields &&
                        this.document.fields.length
                      ) {
                        this.is_show_overwritten_info = true;
                      }

                      this.dataService
                        .apiGetCall('/api/get_document?document_id=' + this.document_id)

                        .subscribe(
                          (documentResponse) => {
                            this.document = documentResponse;

                            if (
                              this.document.fields.length &&
                              this.document.fields[0].json_attributes &&
                              this.document.fields[0].json_attributes.integrations &&
                              this.document.fields[0].json_attributes.integrations.length &&
                              this.document.fields[0].json_attributes.integrations[0]['type']
                            ) {
                              this.pushback_type.name =
                                this.document.fields[0].json_attributes.integrations[0]['type'] ||
                                this.pushback_type.name;
                            }

                            this.updateRoutingAndSetTemplateSettings();
                          },
                          () => {
                            this.updateLoading(false, '');
                            this.updateError(`Can't load document.`);
                          }
                        );
                    },
                    () => {
                      this.updateLoading(false, '');
                      this.updateError(`Fields weren't been imported`);
                      // }
                    }
                  );
              },
              () => {
                this.updateLoading(false, '');
                this.updateError(`Can't load document.`);
              }
            );
        } else {
          this.updateRoutingAndSetTemplateSettings();
        }
      });
  }

  private updateRoutingAndSetTemplateSettings() {
    if (this.document.routing_details.length === 0 && this.document.roles.length > 0) {
      const routing = this.databindingService.createRoutingDetailsObject(this.document);

      this.dataService
        .apiPostCall('/api/update_document_routing?document_id=' + this.document_id, routing)

        .subscribe(() => {
          this.dataService
            .apiGetCall('/api/get_document?document_id=' + this.document_id)

            .subscribe(() => {
              if (this.using_template_setting === true) {
                if (this.template_setting.document_name.length === 0) {
                  this.document_name = this.document.document_name;
                } else {
                  this.document_name = this.template_setting.document_name;
                }
                if (this.template_setting.skip_to_email_invite) {
                  this.skip();
                } else {
                  this.updateLoading(false, '');
                }
              } else {
                this.document_name = this.document.document_name;
                this.updateLoading(false, '');
              }
            });
        });
    } else {
      if (this.using_template_setting == true) {
        if (this.template_setting.document_name.length === 0) {
          this.document_name = this.document.document_name;
        } else {
          this.document_name = this.template_setting.document_name;
        }
        if (this.template_setting.skip_to_email_invite) {
          this.skip();
        }
      } else {
        this.document_name = this.document.document_name;
      }
      this.updateLoading(false, '');
    }
  }

  CloneDocumentWithNewName(new_name, next_view) {
    this.clearErrors();
    this.updateLoading(true, 'Loading Document.');

    if (new_name.split(' ').join('') == '') {
      this.updateError(`Document name can't be empty.`);
      this.updateLoading(false, '');
      return;
    }

    this.dataService
      .apiGetCall('/api/get_document?document_id=' + this.document_id)

      .subscribe((result) => {
        this.document = result;

        if (next_view === this.singningLinkFlag) {
          if (
            this.document.routing_details[0] &&
            this.document.routing_details[0].data &&
            this.document.routing_details[0].data.length
          ) {
            const isDocumentHasAtLeastOneUnixedRole = this.document.routing_details[0].data.some(
              (el) => el.default_email.length === 0
            );
            if (!isDocumentHasAtLeastOneUnixedRole) {
              this.updateError(
                'Document must have at least one role that is not fixed to create an invite link.'
              );
              this.updateLoading(false, '');
              return;
            }
          }
        }

        if (this.document.roles.length === 0) {
          this.updateError('Before you proceed, please edit the document and add the fields with Roles.');
          this.updateLoading(false, '');
        } else {
          if (this.document.document_name === new_name) {
            this.selected_pushback_document = this.document;
            this.dataService.setDocumentId(this.document.id);
            this.dataService.setRoles(this.document.roles);
            // this.dataService.setRoutingDetails(this.document); // now we do this on SEND page component with actual document fields data

            this.dataService
              .apiGetCall('/api/get_document_annotations?document_id=' + this.document.id)

              .subscribe((annotationsResult) => {
                const res: any = JSON.parse(annotationsResult);
                const salesforce_annotations: any = res.integration_objects;
                if (salesforce_annotations != null) {
                  this.data.annotations = [];
                  for (let i = 0; i < salesforce_annotations.length; i++) {
                    this.data.annotations.push(salesforce_annotations[i]);
                  }
                }

                this.dataService.setAnnotations(this.data.annotations);
                this.dataService.setDocumentName(new_name);
                this.dataService.setOriginTemplateId('');
                this.dataService.setDocumentOwner(this.document.owner);
                this.addAnnotationsToDocument(next_view, this.document);
              });
          } else {
            const old_doc_id = this.document_id;
            this.document_name = new_name;
            this.updateLoading(true, 'Generating updated Document.');
            this.dataService
              .apiGetCall(
                '/api/generate_document_from_template?template_id=' +
                  this.document_id +
                  '&new_name=' +
                  new_name
              )

              .subscribe(
                (result) => {
                  // console.log('New Document Id: ' + result.id);
                  this.updateLoading(
                    true,
                    'New document successfully generated. Making call to get document data.'
                  );
                  this.dataService.setDocumentId(result.id);
                  const new_doc_id = result.id;

                  this.dataService
                    .apiGetCall('/api/get_document?document_id=' + new_doc_id)

                    .subscribe((result) => {
                      this.document = result;
                      this.document_id = new_doc_id;
                      this.selected_pushback_document = this.document;
                      this.updateLoading(true, 'Document data received.');
                      this.dataService.setRoles(this.document.roles);
                      // this.dataService.setRoutingDetails(this.document); // now we do this on SEND page component with actual document fields data

                      this.dataService
                        .apiGetCall('/api/get_document_annotations?document_id=' + new_doc_id)

                        .subscribe((result) => {
                          var res: any = JSON.parse(result);
                          var salesforce_annotations: any = res.integration_objects;
                          if (salesforce_annotations != null) {
                            this.data.annotations = [];
                            for (let i = 0; i < salesforce_annotations.length; i++) {
                              this.data.annotations.push(salesforce_annotations[i]);
                            }
                          }

                          this.dataService.setAnnotations(this.data.annotations);
                          this.dataService.setDocumentName(new_name);
                          this.dataService.setOriginTemplateId('');
                          this.dataService.setDocumentOwner(this.document.owner);

                          this.addAnnotationsToDocument(next_view, this.document);
                          this.DeleteDocument(old_doc_id);
                        });
                    });
                },
                (error) => {
                  this.updateError(error.error);
                  this.updateLoading(false, '');
                  return;
                }
              );
          }
        }
      });
  }

  DeleteDocument(old_doc_id) {
    this.dataService.apiGetCall('/api/delete_document?document_id=' + old_doc_id);
  }

  SetupPushBack() {
    this.setTabs('pushback');
    const document = this.selected_pushback_document;
    let valid_fields_count = 0;

    for (let i = 0; i < document.fields.length; i++) {
      if (this.databindingService.isAllowedTypeOfDocumentField(document.fields[i].type)) {
        valid_fields_count++;
      }
      if (
        document.fields[i].json_attributes.name == null ||
        document.fields[i].json_attributes.name === undefined
      ) {
        document.fields[i].json_attributes.name = '';
      }

      if (
        document.fields[i].json_attributes.label == null ||
        document.fields[i].json_attributes.label === undefined
      ) {
        document.fields[i].json_attributes.label = '';
      }
      // "integrations": [{"type": "contact", "field": "phone", "update": "yes", "integration_id": "98e94c607b2be81b9ddec0a8a2388066141b8027"}]
      var integrations;
      if (
        document.fields[i].json_attributes.integrations === undefined ||
        document.fields[i].json_attributes.integrations == null
      ) {
        integrations = [
          {
            type: '',
            field: '',
            update: 'no',
            isAppendToSN: 'no',
            integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
          }
        ];
      } else {
        integrations = document.fields[i].json_attributes.integrations;
      }
      document.fields[i].integrations = integrations;
    }
    if (valid_fields_count === 0) {
      this.display_pushback = false;
    } else {
      this.display_pushback = true;

      if (document.fields && document.fields.length) {
        // set checkboxes for pushback to SF and append to SN
        document.fields.forEach((fieldItem) => {
          const jsonAttr = fieldItem.json_attributes;
          if (jsonAttr.integrations && jsonAttr.integrations.length) {
            fieldItem.isUpdateSfFieldFromDocument = jsonAttr.integrations[0]['update']
              ? jsonAttr.integrations[0]['update'] === 'yes'
              : false;
            fieldItem.isAppendSfFieldIntoSnField = jsonAttr.integrations[0]['isAppendToSN']
              ? jsonAttr.integrations[0]['isAppendToSN'] === 'yes'
              : false;

            if (jsonAttr.integrations[0]['type']) {
              this.pushback_type.name = jsonAttr.integrations[0]['type'] || this.pushback_type.name;
            }
          }
        });
      }
    }
    // this.pushback_type.name = document.fields.length ? document.fields[0].integrations[0].type : '';
    this.selected_pushback_document = document;
  }

  prep_document_for_databinding(document) {
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackTypes);
    const data_binding_types: Set<string> = new Set<string>();
    for (let i = 0; i < document.fields.length; i++) {
      if (
        document.fields[i].json_attributes.name == null ||
        document.fields[i].json_attributes.name == undefined
      ) {
        document.fields[i].json_attributes.name = '';
      }

      if (
        document.fields[i].json_attributes.label == null ||
        document.fields[i].json_attributes.label == undefined
      ) {
        document.fields[i].json_attributes.label = '';
      }
      let integrations;
      if (
        document.fields[i].json_attributes.integrations == undefined ||
        document.fields[i].json_attributes.integrations == null
      ) {
        integrations = [
          {
            type: '',
            field: '',
            update: 'no',
            isAppendToSN: 'no',
            integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
          }
        ];
      } else {
        integrations = document.fields[i].json_attributes.integrations;
        if (
          integrations[0].type != '' &&
          this.databindingService.isAllowedTypeOfDocumentField(document.fields[i].type)
        ) {
          data_binding_types.add(integrations[0].type);
        }
      }
      document.fields[i].integrations = integrations;
    }
    const data_binding_types_arr = Array.from(data_binding_types);
    if (data_binding_types_arr.length > 1) {
      this.updateError(this.pushBackErrorsMsg.duplicatePushbackTypes);
      return document;
    } else {
      // this.pushback_type.name = data_binding_types_arr[0] !== undefined ? data_binding_types_arr[0] : '';
    }
    return document;
  }

  async AppendSFDataToPrefillSNFields(document) {
    this.clearErrors();
    this.updateLoading(true, 'Adding Salesforce Fields to the Document.');

    var new_document = this.prep_document_for_databinding(document);
    var fields = [];
    var field_value_counts = new Map<string, number>();
    var field_value_counts_update = new Map<string, number>();
    var valid_field_count = 0;

    for (let i = 0; i < new_document.fields.length; i++) {
      const value = new_document.fields[i].integrations[0].field;

      if (value !== '' && this.databindingService.isAllowedTypeOfDocumentField(new_document.fields[i].type)) {
        valid_field_count++;
        var count: number = field_value_counts.get(value) == undefined ? 0 : field_value_counts.get(value);
        count++;
        field_value_counts.set(value, count);

        if (new_document.fields[i].isUpdateSfFieldFromDocument === true) {
          const update_count: number =
            field_value_counts_update.get(value) == undefined ? 1 : field_value_counts_update.get(value) + 1;
          field_value_counts_update.set(value, update_count);
        }
      }
    }

    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackField);

    if (valid_field_count > 0 && this.pushback_type.name.split(' ').join('') === '') {
      this.updateError(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
      return false;
    }
    if (valid_field_count == 0 && this.pushback_type.name !== '') {
      this.updateError(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
      return false;
    }
    for (let entry of Array.from(field_value_counts_update.entries())) {
      let count = entry[1];
      if (count > 1) {
        this.updateError(this.pushBackErrorsMsg.duplicatePushbackField);
        return false;
      }
    }

    const salesforce_data = this.dataService.getSalesforceData();
    const params = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      sf_obg_type: this.pushback_type.name,
      sf_obg_id: salesforce_data.record_id
    };

    try {
      const record = await this.dataService
        .apiGetCall('/api/get_record_by_id', { params })

        .toPromise();
      if (record) {
        for (let i = 0; i < new_document.fields.length; i++) {
          if (this.databindingService.isAllowedTypeOfDocumentField(new_document.fields[i].type)) {
            new_document.fields[i].integrations[0].type = this.pushback_type.name;
          }

          const prefilledValueFromForm = new_document.fields[i].integrations[0].field;
          const previousPrefilledValue = new_document.fields[i].json_attributes.prefilled_text;
          const prefilledValueFromRecord = record[prefilledValueFromForm] || previousPrefilledValue;

          const field = this.databindingService.initDefaultFieldForPushback(
            new_document,
            new_document.fields[i]
          );
          field.prefilled_text =
            new_document.fields[i].integrations[0].isAppendToSN === 'yes'
              ? prefilledValueFromRecord
              : previousPrefilledValue;

          field.integrations.push(new_document.fields[i].integrations[0]);
          fields.push(field);
        }

        this.setDatabindingInfoForAnalytics(fields); // only when updating the document that will be sent to Send Page

        try {
          await this.dataService
            .apiPostCall(
              '/api/add_pushback_to_template',
              JSON.stringify({ document_id: new_document.id, pushback_fields: fields })
            )

            .toPromise();
          return true;
        } catch {
          return false;
        }
      } else if (record && record.errorCode) {
        console.log(record.errorCode);
        return false;
      }
    } catch (error) {
      this.updateLoading(false, '');
      this.updateError(error.error);
      return false;
    }
  }

  // todo move to Databinding Service
  // for analytics purpose
  // only when updating the document that will be sent to Send Page
  setDatabindingInfoForAnalytics(fields) {
    const databindingInfoForAnalytics = {
      is_update: fields.some((field) => field.integrations[0].update === 'yes'),
      is_append: fields.some((field) => field.integrations[0].isAppendToSN === 'yes')
    };
    this.dataService.addAnalyticsDatabindingInfo(databindingInfoForAnalytics);
  }

  addAnnotationsToDocument(next_view, new_document) {
    const salesforce = this.dataService.getSalesforceData();
    const data = this.dataService.getData();
    const salesforce_annotation_data = {
      sf_token: salesforce.sf_token,
      instance_url: salesforce.instance_url,
      record_type: salesforce.record_type,
      record_id: salesforce.record_id,
      annotations: data.annotations
    };
    if (next_view === 'pushback') {
      this.SetupPushBack();
      this.setTabs('pushback');
      this.updateLoading(false, '');
    } else if (new_document) {
      this.updateLoading(true, 'Adding annotations data from salesforce to the document.');
      this.dataService
        .apiPostCall(
          '/api/add_annotations_to_document?document_id=' + data.document_id,
          salesforce_annotation_data
        )

        .subscribe(
          async (result) => {
            const res: any = JSON.parse(result);
            if (res.success === false) {
              this.updateLoading(false, '');
              // console.log("error " + res.error);
              this.updateError(res.error);
              this.dataService.setAnnotations([]);
            } else {
              const success = await this.AppendSFDataToPrefillSNFields(new_document);

              if (success === true) {
                if (next_view === this.singningLinkFlag) {
                  this.createDocumentStatus();
                } else {
                  this.router.navigate(['send'], { queryParams: { sending_type: this.sending_type } });
                }
              } else {
                this.updateLoading(false, '');
              }
            }
          },
          () => {
            this.updateError(
              'An error has occured while processing Salesforce annotations. Please make sure that there are no empty Salesforce field values for the annotations.'
            );
            this.updateLoading(false, '');
            return;
          }
        );
    }
  }

  async openSNDocumentTab() {
    var session = await this.dataService.apiGetCall('/api/session').toPromise();
    var sn_token = session.sn_token !== undefined ? session.sn_token : '';
    var redirect_url = window.location.origin + '/close_popup';
    this.edit_document = true;
    this.removeErrorMessage('Before you proceed, please edit the document and add the fields with Roles.');
    this.removeErrorMessage(
      'Document must have at least one role that is not fixed to create an invite link.'
    );

    if (sn_token !== '') {
      this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${APP_BASE_LINK}/webapp/document/${
          this.document_id
        }?access_token=${sn_token}&redirect_uri=${encodeURIComponent(redirect_url)}`
      );
    } else {
      this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${APP_BASE_LINK}/webapp/document/${this.document_id}?redirect_uri=${encodeURIComponent(
          redirect_url
        )}`
      );
    }
  }
  async openSNAnnotationsTab() {
    var session = await this.dataService.apiGetCall('/api/session').toPromise();
    var sn_token = session.sn_token !== undefined ? session.sn_token : '';
    if (sn_token !== '') {
      const url = `${APP_BASE_LINK}/webapp/annotations/${this.document_id}?access_token=${sn_token}&annotation_types=salesforce`;
      window.open(url, '_blank');
    } else {
      const url = `${APP_BASE_LINK}/webapp/annotations/${this.document_id}?annotation_types=salesforce`;
      window.open(url, '_blank');
    }
  }

  clearErrors() {
    this.error_messages = [];
  }
  updateLoadingEvent($event) {
    this.updateLoading($event.state, $event.msg);
  }
  updateLoading(state: boolean, msg: string) {
    this.loading.update(state, msg);
  }
  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }
  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message === this.error_messages[i]) {
        // delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }

  addPushbackDataToDocument(flag: string = '') {
    if (flag === this.singningLinkFlag) {
      if (
        this.document.routing_details[0] &&
        this.document.routing_details[0].data &&
        this.document.routing_details[0].data.length
      ) {
        const isDocumentHasAtLeastOneUnixedRole = this.document.routing_details[0].data.some(
          (el) => el.default_email.length === 0
        );
        if (!isDocumentHasAtLeastOneUnixedRole) {
          this.updateError(
            'Document must have at least one role that is not fixed to create an invite link.'
          );
          this.updateLoading(false, '');
          return;
        }
      }
    }

    // if pushback type isnt specified then skip the pushback
    let field_count = 0;
    let empty_pushback_count = 0;
    if (this.display_pushback === true) {
      this.updateLoading(true, 'Adding pushback data to the template.');
      var fields = [];
      var field_value_counts = new Map<string, number>();
      var field_value_counts_update = new Map<string, number>();
      var valid_field_count = 0;
      for (let i = 0; i < this.selected_pushback_document.fields.length; i++) {
        var value = this.selected_pushback_document.fields[i].integrations[0].field;

        if (
          value !== '' &&
          this.databindingService.isAllowedTypeOfDocumentField(this.selected_pushback_document.fields[i].type)
        ) {
          valid_field_count++;
          var count: number = field_value_counts.get(value) == undefined ? 0 : field_value_counts.get(value);
          count++;
          field_value_counts.set(value, count);

          if (this.selected_pushback_document.fields[i].isUpdateSfFieldFromDocument == true) {
            const update_count: number =
              field_value_counts_update.get(value) == undefined
                ? 1
                : field_value_counts_update.get(value) + 1;
            field_value_counts_update.set(value, update_count);
          }
        }
      }

      this.removeErrorMessage(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
      this.removeErrorMessage(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
      this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackField);

      if (valid_field_count > 0 && this.pushback_type.name.split(' ').join('') === '') {
        this.updateLoading(false, '');
        this.updateError(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
        return;
      }
      if (valid_field_count === 0 && this.pushback_type.name !== '') {
        this.updateLoading(false, '');
        this.updateError(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
        return;
      }
      for (const entry of Array.from(field_value_counts_update.entries())) {
        // let value = entry[0];
        const count = entry[1];
        if (count > 1) {
          this.updateLoading(false, '');
          this.updateError(this.pushBackErrorsMsg.duplicatePushbackField);
          return;
        }
      }

      if (this.pushback_type.name.split(' ').join('') === '' && valid_field_count === 0) {
        this.skip(flag);
        return;
      }

      for (let i = 0; i < this.selected_pushback_document.fields.length; i++) {
        const currentField = this.selected_pushback_document.fields[i];

        if (this.databindingService.isAllowedTypeOfDocumentField(currentField.type)) {
          currentField.integrations[0].type = this.pushback_type.name;
          ++field_count;
        }

        const field: any = this.databindingService.initDefaultFieldForPushback(
          this.selected_pushback_document,
          this.selected_pushback_document.fields[i]
        );

        if (
          this.selected_pushback_document.fields[i].integrations[0].field.split(' ').join('') === '' &&
          this.databindingService.isAllowedTypeOfDocumentField(this.selected_pushback_document.fields[i].type)
        ) {
          empty_pushback_count++;
        }

        const prefilledValueFromForm = currentField.integrations[0].field;
        this.selected_pushback_document.fields[i].integrations[0].update =
          prefilledValueFromForm && this.selected_pushback_document.fields[i].isUpdateSfFieldFromDocument
            ? 'yes'
            : 'no';
        this.selected_pushback_document.fields[i].integrations[0].isAppendToSN =
          prefilledValueFromForm && this.selected_pushback_document.fields[i].isAppendSfFieldIntoSnField
            ? 'yes'
            : 'no';

        if (
          this.selected_pushback_document.fields[i].integrations[0].update === 'no' &&
          this.selected_pushback_document.fields[i].integrations[0].isAppendToSN === 'no'
        ) {
          this.selected_pushback_document.fields[i].integrations[0].field = '';
        }

        field.integrations.push(this.selected_pushback_document.fields[i].integrations[0]);
        fields.push(field);
      }

      if (empty_pushback_count === field_count) {
        this.skip(flag);
        return;
      }

      var type = this.salesforce.record_type;

      if (this.pushback_type.name !== '' && this.pushback_type.name !== type) {
        this.updateLoading(false, '');
        this.updateError(
          `Data Binding record type is set to '${this.pushback_type.name}'. Go to Data Binding settings and choose "${type}" record type to send out this document.`
        );
      } else {
        this.dataService
          .apiPostCall(
            '/api/add_pushback_to_template',
            JSON.stringify({ document_id: this.selected_pushback_document.id, pushback_fields: fields })
          )

          .subscribe(() => {
            this.dataService
              .apiGetCall('/api/get_document?document_id=' + this.selected_pushback_document.id)

              .subscribe((resultDoc) => {
                if (flag === this.singningLinkFlag) {
                  this.addAnnotationsToDocument(flag, resultDoc);
                } else {
                  this.updateLoading(false, '');
                  this.addAnnotationsToDocument('send', resultDoc);
                }
              });
          });
      }
    } else {
      this.dataService
        .apiGetCall('/api/get_document?document_id=' + this.selected_pushback_document.id)

        .subscribe((resultDoc) => {
          if (flag === this.singningLinkFlag) {
            this.addAnnotationsToDocument(flag, resultDoc);
          } else {
            this.updateLoading(false, '');
            this.addAnnotationsToDocument('send', resultDoc);
          }
        });
    }
  }

  createSigningLink() {
    this.updateLoading(false, 'Creating Signing Link');
    this.is_signing_link = true;

    // create_signing_link
    this.dataService
      .apiPostCall('/api/create_signing_link', { document_id: this.document_id })

      .subscribe(
        (result) => {
          if (result && result.url_no_signup) {
            this.signingLinkString = result.url_no_signup;
            this.GA.trackEvent('invite', this.sending_type, 'signing_link');
          }
          this.updateLoading(false, '');
        },
        (error) => {
          this.is_signing_link = false;

          console.log('error', error);
          this.updateLoading(false, '');
        }
      );
  }

  createDocumentStatus() {
    this.updateLoading(true, 'Create Document Status');
    const data = this.dataService.getData();
    const sf_data = this.dataService.getSalesforceData();

    const is_used_annotations = !!this.dataService.getData().annotations.length;
    const databindingForAnalytics: any = this.dataService.getAnalyticsDatabindingInfo()[0] || {
      is_update: false,
      is_append: false
    };
    let roles: any = {};

    try {
      this.dataService.setRoutingDetails(this.document);
      roles = this.using_template_setting
        ? this.template_setting.roles
        : this.dataService.getRoutingDetails()[0].data;
    } catch {
      roles.legnth = -1;
    }
    const analyticsData = this.getAnalyticsDataForSigningLink(
      sf_data,
      roles.length,
      is_used_annotations,
      databindingForAnalytics
    );

    const invite_data: any = {
      aData: analyticsData,
      record_list: this.dataService.getRecordList(),
      sf_user_id: sf_data.sf_user_id,
      sf_org_id: sf_data.sf_org_id,
      sf_token: sf_data.sf_token,
      sf_refresh: sf_data.sf_refresh,
      sf_record_id: sf_data.record_id,
      sf_record_type: sf_data.record_type,
      instance_url: sf_data.instance_url,
      document_name: data.document_name,
      document_id: data.document_id,
      is_signing_link: true
    };

    this.dataService
      .apiPostCall('/api/create_signing_link_doc_status', { data: JSON.stringify(invite_data) })

      .subscribe(
        (result) => {
          this.dataService.saveSentDocumentAsNotesAndAttachments();
          this.dataService.setSNToken(result.sn_token);
          this.createSigningLink();
        },
        (error) => {
          this.updateLoading(false, '');
          this.updateError(error.error);
        }
      );
  }

  getAnalyticsDataForSigningLink(sf_data, rolesLength, is_used_annotations, databindingForAnalytics) {
    const data = this.dataService.getData();
    const is_any_preselected_document_id = !!(
      this.dataService.getUrlParamater('attachment_id') || this.dataService.getUrlParamater('template_id')
    );
    const analytics: any = {
      // doc_status_oids: array of strings, // set this param from backend side - get from doc_status document
      invite: {
        is_signing_link: true, // we already in case when signing link is used
        sending_type: this.sending_type,
        record_type: sf_data.record_type,
        has_preselected_document: is_any_preselected_document_id,
        has_document_flow: this.using_template_setting,
        document_flow_settings: null,
        annotation: {
          is_used: is_used_annotations
        },
        data_binding: {
          is_append: databindingForAnalytics.is_append,
          is_update: databindingForAnalytics.is_update
        },
        signers_count: rolesLength,
        is_self_signer: false,
        sender: this.dataService.getSignNowOwnerEmail() || this.sender_email || data.document_owner_email
      }
    };

    if (this.using_template_setting) {
      analytics.invite.document_flow_settings = {
        has_roles: !!(this.template_setting.roles && this.template_setting.roles.length),
        has_message_subject: !!this.template_setting.subject,
        has_message_body: !!this.template_setting.body,
        has_document_name: !!this.template_setting.document_name,
        has_automatically_send: !!this.template_setting.auto_send,
        has_skip_to_end: !!this.template_setting.skip_to_email_invite,
        has_hide_advanced_settings: !!this.template_setting.is_hide_advanced_settings,
        has_import_fields: !!this.template_setting.template_id
      };
    }

    return analytics;
  }

  changeAdditionalSigningLinkParams() {
    this.signingLinkParams = '';

    if (this.isAllowToInvite) {
      this.signingLinkParams = '?form=true';
    } else {
      this.isInviterWillGuest = false;
    }

    if (this.isInviterWillGuest) {
      this.signingLinkParams += '&guest_signing=true';
    }
  }

  back_to_templates_page() {
    this.dataService.reinitialize();
    this.router.navigate(['templates/']);
  }

  skip(flag: string = '') {
    this.dataService
      .apiGetCall('/api/get_document?document_id=' + this.document_id)

      .subscribe((result) => {
        this.document = result;

        if (this.document.roles.length == 0) {
          this.updateError('Before you proceed, please edit the document and add the fields with Roles.');
        } else {
          this.updateLoading(true, 'Loading document data.');
          this.dataService.setDocumentId(this.document_id);

          this.dataService
            .apiGetCall('/api/get_document?document_id=' + this.document_id)

            .subscribe((result) => {
              this.document = result;

              if (flag !== this.singningLinkFlag) {
                this.selected_pushback_document = this.document;
              }
              this.updateLoading(true, 'Document data received.');
              this.dataService.setRoles(this.document.roles);
              // this.dataService.setRoutingDetails(this.document); // now we do this on SEND page component with actual document fields data
              this.updateLoading(true, 'Getting annotations from document data.');

              this.dataService
                .apiGetCall('/api/get_document_annotations?document_id=' + this.document_id)

                .subscribe((result) => {
                  var res: any = JSON.parse(result);
                  var salesforce_annotations: any = res.integration_objects;
                  if (salesforce_annotations != null) {
                    for (var i = 0; i < salesforce_annotations.length; i++) {
                      this.data.annotations.push(salesforce_annotations[i]);
                    }
                  }
                  this.dataService.setAnnotations(this.data.annotations);
                  this.dataService.setDocumentName(this.document_name);
                  this.dataService.setOriginTemplateId('');
                  this.dataService.setDocumentOwner(this.document.owner);

                  var salesforce = this.dataService.getSalesforceData();
                  var data = this.dataService.getData();
                  var salesforce_annotation_data = {
                    sf_token: salesforce.sf_token,
                    instance_url: salesforce.instance_url,
                    record_type: salesforce.record_type,
                    record_id: salesforce.record_id,
                    annotations: data.annotations
                  };
                  this.updateLoading(true, 'Adding annotations data from salesforce to the document.');
                  this.dataService
                    .apiPostCall(
                      '/api/add_annotations_to_document?document_id=' + data.document_id,
                      salesforce_annotation_data
                    )

                    .subscribe(
                      (result) => {
                        const res: any = JSON.parse(result);

                        if (res.success == true) {
                          // console.log(res.body);
                          if (flag === this.singningLinkFlag) {
                            this.createDocumentStatus();
                            return;
                          } else {
                            this.router.navigate(['send'], {
                              queryParams: { sending_type: this.sending_type }
                            });
                          }
                        } else {
                          // console.log("error " + res.error);
                          this.updateError(res.error);
                          this.dataService.setAnnotations([]);
                        }

                        this.updateLoading(false, '');
                      },
                      () => {
                        this.updateError(
                          'An error has occured while processing Salesforce annotations. Please make sure that there are no empty Salesforce field values for the annotations.'
                        );
                        this.updateLoading(false, '');
                        return;
                      }
                    );
                });
            });
        }
      });
  }

  async loadSalesforceDataIntoDataService() {
    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    var sf_token = this.salesforce_session_data.sf_token;
    var sf_refresh = this.salesforce_session_data.sf_refresh;
    var sf_org_id = this.salesforce_session_data.sf_org_id;
    var sf_user_id = this.salesforce_session_data.sf_user_id;
    var instance_url = this.salesforce_session_data.instance_url;
    var record_type = this.salesforce_session_data.record_type;
    var record_id = this.salesforce_session_data.record_id;
    var context = this.salesforce_session_data.context;
    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      return;
    }
    // set information in data service
    this.dataService.setSalesforceRefresh(sf_refresh);
    this.dataService.setSalesforceToken(sf_token);
    this.dataService.setSalesforceOrgId(sf_org_id);
    this.dataService.setSalesforceUserId(sf_user_id);
    this.dataService.setSalesforceInstanceUrl(instance_url);
    this.dataService.setSalesforceRecordType(record_type);
    this.dataService.setSalesforceRecordId(record_id);
    this.dataService.setSalesforceContext(context);
  }

  copySigningLinkToClipboard(signingLinkInput) {
    signingLinkInput.select();
    document.execCommand('copy');
    this.isCopiedToClipboard = true;

    setTimeout(() => {
      this.isCopiedToClipboard = false;
    }, 5000);
  }
}
